import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs';
import { UsersService } from './users.service';

export class UsersDataSource extends DataSource<any> {
  constructor(private usersService: UsersService, private schoolId: string | null) {
    super();
  }

  connect(): Observable<any[]> {
    return this.usersService.getUsers(this.schoolId);
  }

  override disconnect(): void {
    // throw new Error('Method not implemented.');
  }
}
